import { useQuery } from "@tanstack/react-query";
import { 
  getHPDViolations, 
  getHPDViolationById,
  getHPDTickets,
  getHPDTicketById,
  getViolationCodes,
  getHPDViolationNotes,
  getPendingHireRequests,
  getAcceptHireRequests,
  getHPDViolationAffidavits,
  getHPDAffidavitCategories
} from "../sevices/violationsApi";

export function useHPDViolations(filters) {
  const { isLoading, data, error, isError, refetch, isRefetching } = useQuery({
    queryKey: ["hpd-violations", filters],
    queryFn: () => getHPDViolations(filters),
    keepPreviousData: true,
  });

  const responseData =
    data?.data?.data?.response_data?.map((el, idx) => {
      return {
        ...el,
        id: idx + 1,
      };
    }) || [];

  const totalRecords = data?.data?.data?.total_records || 0;

  return {
    isLoading,
    error,
    responseData,
    isError,
    refetch,
    totalRecords,
    isRefetching,
  };
}

export function useHPDViolationById(id) {
  const { isLoading, data, error, isError, refetch } = useQuery({
    queryKey: ["hpd-violation", id],
    queryFn: () => getHPDViolationById(id),
    enabled: !!id, // Only run the query if id is provided
  });

  const responseData = data?.data?.data?.response_data;

  return { isLoading, error, responseData, isError, refetch };
}

export function useHPDTickets(filters, clientId) {
  const { isLoading, data, error, isError, refetch, isRefetching } = useQuery({
    queryKey: clientId ? ["hpd-tickets", clientId] : ["hpd-tickets"],
    queryFn: () => getHPDTickets(filters),
    keepPreviousData: true,
  });

  const responseData =
    data?.data?.response_data?.tickets?.map((el, idx) => {
      return {
        ...el,
        id: idx + 1,
      };
    }) || [];

  const totalRecords = data?.data?.response_data?.total_records || 0;
  const statusCounts = data?.data?.response_data?.status_counts;

  return {
    isLoading,
    error,
    responseData,
    isError,
    refetch,
    totalRecords,
    isRefetching,
    statusCounts,
  };
}

export function useViolationCodes() {
  const { isLoading, data, error, isError, refetch } = useQuery({
    queryKey: ["violation-codes"],
    queryFn: () => getViolationCodes(),
  });

  const responseData = data?.data?.response_data || [];

  return { isLoading, error, responseData, isError, refetch };
}

export function useHPDTicketById(id) {
  const { isLoading, data, error, isError, refetch } = useQuery({
    queryKey: ["hpd-ticket", id],
    queryFn: () => getHPDTicketById(id),
    enabled: !!id,
  });

  const responseData = data?.data?.response_data;

  return { isLoading, error, responseData, isError, refetch };
}

export function useHPDTicketNotes(id) {
  const { isLoading, data, error, isError, refetch } = useQuery({
    queryKey: ["hpd-ticket-notes", id],
    queryFn: () => getHPDViolationNotes(id),
    enabled: !!id,
  });

  const responseData = data?.data?.response_data;

  return { isLoading, error, responseData, isError, refetch };
}

export function usePendingHireRequests(filters) {
  const { isLoading, data, error, isError, refetch } = useQuery({
    queryKey: ["pending-hire-requests", filters],
    queryFn: () => getPendingHireRequests(filters),
    retry: 1,
  });

   const responseData =
     data?.data?.data?.response_data?.map((el, idx) => {
       return {
         ...el,
         id: idx + 1,
       };
     }) || [];

  const statusCounts = data?.data?.data?.status_counts;
  const totalRecords = data?.data?.data?.total_records || 0;

  return { isLoading, error, responseData, isError, refetch, statusCounts, totalRecords };
}

export function useAcceptHireRequests(filters) {
  const { isLoading, data, error, isError, refetch } = useQuery({
    queryKey: ["accept-hire-requests", filters],
    queryFn: () => getAcceptHireRequests(filters),
    retry: 1,
  });

  const responseData = data?.data?.data?.response_data?.map((el, idx) => {
    return {
      ...el,
      id: idx + 1,
    };
  }) || [];

  const totalRecords = data?.data?.data?.total_records || 0;

  return { isLoading, error, responseData, isError, refetch, totalRecords };
}



export function useHPDViolationAffidavits() {
  const { isLoading, data, error, isError, refetch } = useQuery({
    queryKey: ["hpd-violation-affidavits"],
    queryFn: () => getHPDViolationAffidavits(),
  });

  const responseData = data?.data?.data;

  return { isLoading, error, responseData, isError, refetch };
}

export function useHPDAffidavitCategories() {
  const { isLoading, data, error, isError, refetch } = useQuery({
    queryKey: ["hpd-affidavit-categories"],
    queryFn: () => getHPDAffidavitCategories(),
  });

  const responseData = data?.data?.data;

  return { isLoading, error, responseData, isError, refetch };
}